var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27588 5.14722C9.27588 5.59851 8.91003 5.96436 8.45874 5.96436C8.00745 5.96436 7.6416 5.59851 7.6416 5.14722C7.6416 4.69592 8.00745 4.33008 8.45874 4.33008C8.91003 4.33008 9.27588 4.69592 9.27588 5.14722Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67676 6.80176V11.5967H9.17676V6.80176H7.67676Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.26465 8.04395C1.26465 4.07062 4.48566 0.849609 8.45898 0.849609C12.4323 0.849609 15.6533 4.07062 15.6533 8.04395C15.6533 12.0173 12.4323 15.2383 8.45898 15.2383C4.48566 15.2383 1.26465 12.0173 1.26465 8.04395ZM8.45898 2.34961C5.31409 2.34961 2.76465 4.89905 2.76465 8.04395C2.76465 11.1888 5.31409 13.7383 8.45898 13.7383C11.6039 13.7383 14.1533 11.1888 14.1533 8.04395C14.1533 4.89905 11.6039 2.34961 8.45898 2.34961Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c9d1132946ea75df402a5a48d794b638.svg";
export { ForwardRef as ReactComponent };